<iframe id="preview" width="100%" height="500px" [src]="content" onerror="iframeError()">
    <p>Seu navegador não suporta a visualização.</p>
</iframe>

<button *ngIf="index > 0" mat-raised-button color="primary" (click)="changeFile(index-1)">Anterior</button>
<button *ngIf="updatedFileId.length > 1 && index < updatedFileId.length-1" mat-raised-button color="primary" style="float: right;" (click)="changeFile(index+1)" >Próximo</button>

<p>* Alguns arquivos podem não ser visualizados.</p>